import { Box, Image } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import telsiaiLogoImage from '../assets/telsiai_header.png';
import jonavaLogoImage from '../assets/jonava.jpeg';
import plungeLogoImage from '../assets/plunge_logo.png';
import marijampoleLogoImage from '../assets/marijampole-logo.svg';
import kedbusasLogoImage from '../assets/kedbusas.png';

const telsiaiLogo = <Box><Link to='/'><Image src={telsiaiLogoImage} /></Link></Box>;
const jonavaLogo = <Box><Link to='/'><Image src={jonavaLogoImage} /></Link></Box>;
const plungeLogo = <Box p='1rem'><Link to='/'><Image h="80px" src={plungeLogoImage} /></Link></Box>;
const marijampoleLogo = <Box p='1rem'><Link to='/'><Image h="50px" src={marijampoleLogoImage} /></Link></Box>;
const kebusasLogo = <Box p='1rem'><Link to='/'><Image h="50px" src={kedbusasLogoImage} /></Link></Box>;

let config = {};

switch (window.location.hostname) {
  case 'marijampole.dutrys.lt':
    config = {
      baseUrl: 'https://trcapi.dutrys.com/api/v3/buckets/70/legacy',
      logo: marijampoleLogo,
      mapCenter: [54.5566132,23.3633391],
    };
    break;

  case 'marsrutai.telsiuap.lt':
  case 'telsiai.dutrys.lt':
    config = {
      baseUrl: 'https://trcapi.dutrys.com/api/v3/buckets/78/legacy',
      logo: telsiaiLogo,
      mapCenter: [55.984734, 22.251782],
    };
    break;

  case 'kedainiai.dutrys.lt':
    config = {
      baseUrl: 'https://trcapi.dutrys.com/api/v3/buckets/102/legacy',
      logo: kebusasLogo,
      mapCenter: [55.2770597, 23.9562228],
    };
    break;

  case 'jonava.dutrys.lt':
    config = {
      baseUrl: 'https://trcapi.dutrys.com/api/v3/buckets/51/legacy',
      logo: jonavaLogo,
      mapCenter: [55.0788587,24.2637209],
    };
    break;

  case 'plunge.dutrys.lt':
  case 'marsrutai.plungesap.lt':
    config = {
      baseUrl: 'https://trcapi.dutrys.com/api/v3/buckets/91/legacy',
      logo: plungeLogo,
      mapCenter: [55.912915,21.830539],
    };
    break;

  default:
    config = {
      baseUrl: 'http://localhost:3002/api/v3/buckets/70/legacy',
      // baseUrl: 'http://localhost:3002/api/v3/buckets/67/legacy',
      // baseUrl: 'https://trcapi.dutrys.com/api/v3/buckets/67/legacy',
      // baseUrl: 'https://tracker.dutrys.com/api/v2/bucket/67',
      logo: marijampoleLogo,
      mapCenter: [55.250398, 22.291265],
    };
    break;
}

export default config;
